import { render, staticRenderFns } from "./MyCampaign.vue?vue&type=template&id=2dfe4b4c&scoped=true&"
import script from "./MyCampaign.vue?vue&type=script&lang=js&"
export * from "./MyCampaign.vue?vue&type=script&lang=js&"
import style0 from "./MyCampaign.vue?vue&type=style&index=0&id=2dfe4b4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfe4b4c",
  null
  
)

export default component.exports